import { render, staticRenderFns } from "./ListagemTiposUso.vue?vue&type=template&id=388e0b98&"
import script from "./ListagemTiposUso.vue?vue&type=script&lang=js&"
export * from "./ListagemTiposUso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports